<template>
  <v-select-with-validation
    v-bind="$attrs"
    v-on="$listeners"
    :items="items"
  >
    <template v-slot:item="{ item }">
      <v-list-item-content
        :class="item.class"
      >
        {{ item[itemText] }}
      </v-list-item-content>
    </template>
  </v-select-with-validation>
</template>

<style scoped>

</style>

<script>
  import collect from 'collect.js';
  import { all } from '@/api/role'

  export default {
    name: 'RoleSelect',
    props: {
      itemText: {
        type: String,
        default() {
          return 'text';
        },
      },
      itemValue: {
        type: String,
        default() {
          return 'value';
        },
      },
    },
    data() {
      return {
        roles: [],
        loading: false,
      };
    },
    computed: {
      items() {
        return [
          { [this.itemText]: this.$t('All Roles'), [this.itemValue]: null, class: 'font-weight-bold' },
          ...this.roles,
        ];
      },
    },
    methods: {
      async fetch() {
        try {
          this.loading = true;
          this.roles = collect(await all()).map(value => ([
            {
              ...collect(value).except('children').all(),
              class: 'font-weight-bold'
            },
            ...value.children.map(item => ({
              ...item,
              class: 'font-weight-regular pl-3',
            })),
          ]))
            .collapse()
            .values()
            .all();
        } catch (e) {
          console.log(e);
        } finally {
          this.loading = false;
        }
      },
    },
    mounted() {
      this.fetch();
    },
  };
</script>

